/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelsend1Inputs */

const en_channelsend1 = /** @type {(inputs: Channelsend1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send announcement`)
};

const de_channelsend1 = /** @type {(inputs: Channelsend1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ankündigung senden`)
};

/**
* | output |
* | --- |
* | "Send announcement" |
*
* @param {Channelsend1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelsend1 = /** @type {((inputs?: Channelsend1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelsend1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelsend1(inputs)
	return de_channelsend1(inputs)
});
export { channelsend1 as "channelSend" }